import { render, staticRenderFns } from "./personlist.vue?vue&type=template&id=03fb1030&lang=pug&"
import script from "./personlist.vue?vue&type=script&lang=js&"
export * from "./personlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03fb1030')) {
      api.createRecord('03fb1030', component.options)
    } else {
      api.reload('03fb1030', component.options)
    }
    module.hot.accept("./personlist.vue?vue&type=template&id=03fb1030&lang=pug&", function () {
      api.rerender('03fb1030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/personlist/personlist.vue"
export default component.exports